// extracted by mini-css-extract-plugin
module.exports = {"scoreContent":"ScoreContainer_scoreContent__2CKmr","scoreValue":"ScoreContainer_scoreValue__28ECd","loaderWrapper":"ScoreContainer_loaderWrapper__2bBIT"};